import { render } from "./ProfileEditContactContent.vue?vue&type=template&id=6d7f23ca&scoped=true"
import script from "./ProfileEditContactContent.vue?vue&type=script&lang=js"
export * from "./ProfileEditContactContent.vue?vue&type=script&lang=js"

import "./ProfileEditContactContent.vue?vue&type=style&index=0&id=6d7f23ca&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7f23ca"]])

export default __exports__